import { render, staticRenderFns } from "./OperatorRole.vue?vue&type=template&id=66c45906&scoped=true"
import script from "./OperatorRole.vue?vue&type=script&lang=js"
export * from "./OperatorRole.vue?vue&type=script&lang=js"
import style0 from "./OperatorRole.vue?vue&type=style&index=0&id=66c45906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c45906",
  null
  
)

export default component.exports